module.exports = __webpack_public_path__ + "static/media/song_on_spotify_site.2ad49dd4.PNG";